export default {
  'menu.payment.userPaymentReview': 'مراجعة مدفوعات المستخدم (Migrated)',
  'menu.marketing': 'التسويق',
  'menu.marketing.marketingCampaigns': 'الحملات التسويقية (تم نقلها)',
  'menu.marketing.promoCampaigns': 'قائمة الحملات الترويجية (Migrated)',
  'menu.marketing.newPromoCampaign': 'إضافة حملة ترويجية',
  'menu.marketing.duplicatePromoCampaign': 'نسخ حملة ترويجية',
  'menu.welcome': 'مرحبا',
  'menu.more-blocks': 'المزيد من الكتل',
  'menu.home': 'الرئيسية',
  'menu.login': 'تسجيل الدخول',
  'menu.register': 'تسجيل',
  'menu.register.result': 'نتيجة التسجيل',
  'menu.dashboard': 'لوحة التحكم',
  'menu.dashboard.analysis': 'التحليلات',
  'menu.dashboard.monitor': 'المراقبة',
  'menu.dashboard.workplace': 'مكان العمل',
  'menu.reports': 'التقارير',
  'menu.payment': 'الدفع',
  'menu.payment.payin': 'تقرير الاستلام',
  'menu.payment.monthlyPayinDueMigrated': 'الاستلام الشهري المستحق (منقول)',
  'menu.payment.payinDetails': 'تفاصيل الاستلام',
  'menu.payment.payout': 'تقرير الدفع',
  'menu.payment.monthlyPayoutDueMigrated':
    'استحقاق الدفع الشهري الجديد (مهاجر)',
  'menu.payment.payinOverrides': 'تقرير تجاوزات الاستلام',
  'menu.payment.paymentClaim': 'تقرير مطالبات الدفع',
  'menu.payment.payoutFinance': 'تقرير المالية للمدفوعات',
  'menu.payment.refundRequests': 'طلبات استرداد الأموال',
  'menu.user': 'المستخدم',
  'menu.user.profile': 'ملف المستخدم',
  'menu.user.profileDetail': 'تفاصيل ملف المستخدم',
  'menu.user.sanctionedUser': 'المستخدم المحظور',
  'menu.risk': 'المخاطر',
  'menu.risk.amlRequests': 'طلبات AML',
  'menu.risk.proofOfIncome': 'إثبات الدخل',
  'menu.dvsRequests': 'طلبات DVS',
  'menu.dvsRequests.mobileValidation': 'التحقق من الموبايل',
  'menu.onboarding': 'التسجيل',
  'menu.onboarding.agreementContract': 'العقد الاتفاقي',
  'menu.onboarding.agreementContractDetail': 'تفاصيل العقد الاتفاقي',
  'menu.onboarding.nationalId': 'هويات الرقم القومي',
  'menu.card': 'البطاقة',
  'menu.card.niApisConsumption': 'استهلاك واجهات برمجة تطبيقات NI',
  'menu.card.hubsLocations': 'مواقع المراكز',
  'menu.card.cashbackTransactions': 'رفع معاملات استرداد النقود',
  'menu.cardCenter': 'مركز البطاقات',
  'menu.cardCenter.p2pTransfers': 'التحويلات',
  'menu.cardCenter.p2pRequiresAttention': 'تتطلب انتباه',
  'menu.cardShopsRewards': 'متاجر وعروض الكارت',
  'menu.cardShopsRewards.merchants': 'التجار',
  'menu.cardShopsRewards.merchantsAdd': 'إضافة تاجر',
  'menu.cardShopsRewards.merchantsEdit': 'تعديل تاجر',
  'menu.cardShopsRewards.offers': 'العروض',
  'menu.cardShopsRewards.offersAdd': 'إضافة عرض',
  'menu.cardShopsRewards.offersEdit': 'تعديل العرض',
  'menu.cardShopsRewards.offersDuplicate': 'تكرار العرض',
  'menu.cardShopsRewards.cashbackOffers': 'كاش باك الكارت (تم النقل)',
  'menu.cardShopsRewards.cashbackOffersAdd': 'إضافة عرض كاش باك الكارت',
  'menu.cardShopsRewards.cashbackOffersEdit': 'تعديل عرض كاش باك الكارت',
  'menu.cardShopsRewards.cardPromoCodeCampaigns':
    'حملات أكواد خصم البطاقة (تم النقل)',
  'menu.cardShopsRewards.cardPromoCodeCampaignsNew': 'حملة كود خصم بطاقة جديدة',
  'menu.integration': 'التكامل',
  'menu.integration.payinMerchants': 'تجار الاستلام',
  'menu.integration.historyAnalytics': 'السجل والتحليلات',
  'menu.integration.userKyc': 'تقرير اعرف عميلك',
  'menu.admin': 'الإدارة',
  'menu.admin.accessManagement': 'إدارة الوصول',
  'menu.payoutCenter': 'مركز الدفع',
  'menu.payoutCenter.readyForPayout': 'جاهز للدفع',
  'menu.payoutCenter.batchesConfiguration': 'تكوين الدفعات',
  'menu.payoutCenter.batchesHistory': 'سجل الدفعات',
  'menu.payoutCenter.batchesCenter': 'مركز الدفعات',
  'menu.circles': 'الدوائر',
  'menu.circles.dashboard': 'لوحة تحكم الدوائر',
  'menu.circles.leaveBundleRequests': 'طلبات مغادرة الحزمة (مهاجرة)',
  'menu.circles.leaveRequests': 'طلبات المغادرة',
  'menu.circles.circlesMigrated': 'الدوائر (مُرحّلة)',
  'menu.corporate': 'الشركات',
  'menu.corporate.organization': 'تقرير المنظمات',
  'menu.corporate.organizationDetails': 'تفاصيل المنظمة',
  'menu.marketing.marketingGoals': 'أهداف التسويق',
  'menu.marketing.marketingCarousels': 'البطاقات التسويقية الدوارة',
  'menu.quotaManagement': 'إدارة الحصص',
  'menu.quotaManagement.hierarchy': 'التسلسل الهرمي',
  'menu.quotaManagement.dashboard': 'لوحة التحكم',
  'menu.quotaManagement.myQuota': 'حصتي',
  'menu.quotaManagement.slotAllocation': 'تخصيص الخانات',
  'menu.operations': 'العمليات',
  'menu.operations.deadLetterMessages': 'رسائل الرسائل الميتة',
  'menu.operations.deadLetterMessagesDetail': 'تفاصيل الرسالة الميتة',
  'menu.reports.userReports.sanctionedUser': 'المستخدم المحظور',
  'menu.pricingManagement': 'إدارة التسعير',
  'menu.pricingManagement.rules': 'القواعد',
  'menu.pricingManagement.distribution': 'التوزيع',
  'menu.moneyfellowsServices': 'خدمات موني فيلوز',
  'menu.moneyfellowsServices.requests': 'طلبات خدمات موني فيلوز',
  'menu.pricingManagement.segments': 'الشرائح',
  'menu.pricingManagement.segmentsAdd': 'شريحة جديدة',
  'menu.pricingManagement.segmentsEdit': 'تعديل الشريحة',
  'menu.pricingManagement.audit': 'سجل التغييرات',
};
